var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPageFirst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-left-double-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.02492 10.0006L9.33538 14.3111L10.3175 13.329L6.9891 10.0006L10.3175 6.67219L9.33538 5.6901L5.02492 10.0006ZM8.94844 10.0006L13.2589 14.3111L14.2411 13.329L10.9127 10.0006L14.2411 6.67219L13.2589 5.6901L8.94844 10.0006Z",
    fill: "#0A0D14"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPageFirst);
export default __webpack_public_path__ + "static/media/icon-page-first.d2d6d98e4ef092b8414905debee4f76c.svg";
export { ForwardRef as ReactComponent };